import { fetchFactory, urlUtils } from 'isotope-client'
import { Competence, CompetenceFilters, CompetenceFormValues, UpdateCompetencePayload } from './competence.types'

const ROOT = '/bo/competence'

/**
 * Récupération de la liste des compétences, filtrée par nom
 * @param filters filtres de l'écran
 */
export const getCompetences = (filters: CompetenceFilters) => fetchFactory<Competence[]>(urlUtils.buildUrlWithParams(ROOT, filters))

/**
 * Création d'une compétence
 * @param values valeurs du formulaire
 */
export const createCompetence = (values: CompetenceFormValues) => fetchFactory<Competence>(ROOT, {
	method: 'POST',
	body: JSON.stringify(values)
})

/**
 * Mise à jour d'une compétence
 * @param payload identifiant, nom et description
 */
export const updateCompetence = (payload: UpdateCompetencePayload) => fetchFactory<Competence>(ROOT, {
	method: 'PUT',
	body: JSON.stringify(payload)
})
